/**
 * Labstep
 *
 * @module components/EntityStateWorkflow/Card
 * @desc EntityStateWorkflow Card
 */

import { EntityStateWorkflowActionMenu } from 'labstep-web/components/EntityStateWorkflow/Action/Menu';
import { GenericCard } from 'labstep-web/core/Card/Generic';
import type React from 'react';
import type { EntityStateWorkflowCardProps } from './types';

export const EntityStateWorkflowCard: React.FC<
  EntityStateWorkflowCardProps
> = ({ entityStateWorkflow, actions }) => (
  <GenericCard
    headerTitle={{
      to: 'entity_state_workflow_show',
      params: { id: entityStateWorkflow.id },
      title: entityStateWorkflow.displayName,
    }}
    actionMenu={
      actions && (
        <EntityStateWorkflowActionMenu
          entityStateWorkflow={entityStateWorkflow}
          actions={actions}
        />
      )
    }
  />
);
